import { createAction, props } from '@ngrx/store';
import { type IEntityAction } from '@principle-theorem/ng-shared';
import {
  IPerioRecord,
  IPerioTableCell,
} from '@principle-theorem/principle-core/interfaces';
import { type SerialisedData } from '@principle-theorem/shared';
import { type ChartId } from '../reducers/active-charts/chart-context-state';
import { ChartActionTypes } from './action-types';

interface IUpsertPerioChart extends IEntityAction<ChartId> {
  perioRecords: IPerioRecord[];
}

export const upsertPerioChart = createAction(
  ChartActionTypes.UpsertPerioChart,
  props<SerialisedData<IUpsertPerioChart>>()
);

interface IUpsertPerioValueData extends IEntityAction<ChartId> {
  changes: IPerioTableCell[];
}

export const upsertPerioValue = createAction(
  ChartActionTypes.UpsertPerioValue,
  props<SerialisedData<IUpsertPerioValueData>>()
);

interface IDeletePerioValueData extends IEntityAction<ChartId> {
  cells?: IPerioTableCell[];
}

export const deletePerioValues = createAction(
  ChartActionTypes.DeletePerioValues,
  props<SerialisedData<IDeletePerioValueData>>()
);
